/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  var addToCartButton = document.querySelector('.add-to-cart');
  var buyNowContainer = document.getElementById('buyNowContainer');
  var modal = document.getElementById('variantModal');
  var span = document.getElementsByClassName('closeModal')[0];
  var confirmButton = document.getElementById('confirmSelection');
  var actionType = ''; // Vai armazenar o tipo de ação: 'cart' ou 'buy'
  var variantTitleElement = document.getElementById('variant-title');
  
  // Função para atualizar o texto do botão e abrir o modal
  function openModal(event, type) {
    event.preventDefault();
    console.log(event,type);
    actionType = type;
    updateButtonText(); // Atualiza o texto do botão no modal
    modal.style.display = 'block';
  }

  // Função para atualizar o texto do botão com base na variante selecionada
  function updateButtonText() {
    var variantSelector = document.querySelector('[name="id"]');
    if (variantSelector) {
      var selectedVariantId = variantSelector.value;
      var selectedVariant = productVariants.find(variant => variant.id == selectedVariantId);
      if (selectedVariant) {
        variantTitleElement.textContent = selectedVariant.title; // Atualiza o título no modal
        // Garantir que o atributo data-action não seja adicionado
        if (addToCartButton) {
          addToCartButton.removeAttribute('data-action');
        }
      }
    }
  }

  // Adiciona o evento de clique no botão "Adicionar ao Carrinho"
  if (addToCartButton) {
    addToCartButton.onclick = function(event) {
      openModal(event, 'cart');
    };
  }

  // Botão "Compre Já" adiciona o evento de clique
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      var buyNowButton = buyNowContainer.querySelector('button');
      if (buyNowButton) {
        buyNowButton.onclick = function(event) {
          openModal(event, 'buy');
        };
      }
    });
  });

  observer.observe(buyNowContainer, { childList: true });

  // Função para fechar o modal
  span.onclick = function() {
    modal.style.display = 'none';
  };

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  };

  // Confirma a seleção e prossegue com a ação original
  confirmButton.onclick = function() {
    modal.style.display = 'none';
    if (actionType === 'cart') {
      // Apenas adiciona o atributo data-action se a ação for 'cart'
      if (addToCartButton) {
        addToCartButton.setAttribute('data-action', 'add-to-cart');
        addToCartButton.click(); // Simula o clique no botão "Adicionar ao Carrinho"
        addToCartButton.removeAttribute('data-action');
      }
    } else if (actionType === 'buy') {
      var buyNowButton = buyNowContainer.querySelector('button');
      if (buyNowButton) {
        buyNowButton.click(); // Simula o clique no botão "Compre Já"
      }
    }
  };

  // Atualiza o texto do botão do modal sempre que a variante é alterada
  var variantSelector = document.querySelector('[name="id"]');
  if (variantSelector) {
    variantSelector.addEventListener('change', updateButtonText);
    updateButtonText(); // Atualiza o texto do botão ao carregar a página
  }
});


